<div class="flex flex-column gap-4 w-29rem">
  <span [innerHTML]="'COMPANY.WHATSAPP_DIALOG.INFO_TEXT' | translate"> </span>
  <span [innerHTML]="'COMPANY.WHATSAPP_DIALOG.READ_GDPR_GUIDELINES' | translate"> </span>
  <div>
    <input
      class="w-full"
      pInputText
      [formControl]="phoneNumberControl"
      [placeholder]="'COMPANY.WHATSAPP_DIALOG.PHONE_NUMBER_PLACEHOLDER' | translate"
    />
    @if (phoneNumberControl.touched && phoneNumberControl.invalid) {
      <small class="text-red-500">
        {{ 'VALIDATION_ERRORS.WHATSAPP_NUMBER_INVALID' | translate }}
      </small>
    }
  </div>
  <div class="flex align-items-center gap-2">
    <p-checkbox [binary]="true" [formControl]="agreeTermsControl" />
    <label [innerHTML]="'COMPANY.WHATSAPP_DIALOG.AGREE_TEXT' | translate"></label>
  </div>
  <p-button
    [label]="'COMPANY.WHATSAPP_DIALOG.AGREE_BUTTON_TEXT' | translate"
    class="align-self-end"
    (click)="addWhatsappNumber()"
    [disabled]="phoneNumberControl.invalid || !agreeTermsControl.value"
  />
</div>
